import type { AboutSustainabilityContent } from '../types/AboutSustainabilityContent';
import type { CompanyFocusTopicElement, GovernanceRoleElement } from '../types/SiteContentElement';

export function createAboutSustainabilityContentPlaceholder(): AboutSustainabilityContent {
    const emptyText = { kind: 'plainText' as const, key: '', content: '' };
    const emptyTextOptional = { kind: 'plainTextOptional' as const, key: '', content: null };
    const emptyMulti = { kind: 'plainMultilineText' as const, key: '', content: '' };
    const emptyImage = { kind: 'image' as const, key: '', imageUrl: '' };
    const emptyRich = { kind: 'richText' as const, key: '', content: '', sanitizedContent: '' };
    const emptyRichOptional = {
        kind: 'richTextOptional' as const,
        key: '',
        content: null,
        sanitizedContent: null,
    };
    const emptyLinks = { kind: 'linkCollection' as const, key: '', links: [] };
    const emptyRoleList = [] as GovernanceRoleElement[];
    const emptyCompanyFocusTopicList = [] as CompanyFocusTopicElement[];

    return {
        pageTitle: emptyText,
        pageSubtitle: emptyMulti,
        pageTitleBackgroundImage: emptyImage,
        Governance: {
            title: emptyText,
            mainText: emptyRich,
            additionalText: emptyRich,
            mainImage: emptyImage,
            esgReportLinks: emptyLinks,
            links: emptyLinks,
            Executives: {
                title: emptyText,
                ExecutiveOfficers: { title: emptyText, entries: emptyRoleList },
                SalesBusinessGroup: { title: emptyText, entries: emptyRoleList },
                ProductBusinessGroups: { title: emptyText, entries: emptyRoleList },
                CorporateInfrastructureUnits: { title: emptyText, entries: emptyRoleList },
            },
            BoardMembers: {
                title: emptyText,
                BoardOfDirectors: { title: emptyText, entries: emptyRoleList },
                RemunerationCommittee: { title: emptyText, entries: emptyRoleList },
                AuditCommittee: { title: emptyText, entries: emptyRoleList },
                OperatingStatus: { title: emptyText, links: emptyLinks },
            },
            Focus: {
                title: emptyText,
                mainText: emptyRichOptional,
                links: emptyLinks,
            },
        },
        Social: {
            title: emptyText,
            mainText: emptyRich,
            mainImage: emptyImage,
            YageoFocus: {
                title: emptyText,
                entries: emptyCompanyFocusTopicList,
            },
            KemetFocus: {
                title: emptyText,
                entries: emptyCompanyFocusTopicList,
            },
        },
        SupplyChain: {
            title: emptyText,
            mainText: emptyRich,
            mainImage: emptyImage,
            YageoFocus: {
                title: emptyText,
                entries: emptyCompanyFocusTopicList,
            },
            KemetFocus: {
                title: emptyText,
                entries: emptyCompanyFocusTopicList,
            },
        },
        Environmental: {
            title: emptyText,
            mainText: emptyRich,
            mainImage: emptyImage,
            link: { kind: 'internalLink', key: '', linkText: '', linkRoute: '' },
            YageoFocus: {
                title: emptyText,
                entries: emptyCompanyFocusTopicList,
            },
            KemetFocus: {
                title: emptyText,
                intro: {
                    title: emptyTextOptional,
                    summary: emptyRichOptional,
                },
                entries: emptyCompanyFocusTopicList,
            },
        },
        Quality: {
            title: emptyText,
            mainText: emptyRich,
            mainImage: emptyImage,
            YageoFocus: {
                title: emptyText,
                entries: emptyCompanyFocusTopicList,
            },
            KemetFocus: {
                title: emptyText,
                entries: emptyCompanyFocusTopicList,
            },
        },
        Resources: {
            title: emptyText,
        },
    };
}
